import { Injectable } from '@angular/core';
import {DialogUtility} from "@syncfusion/ej2-angular-popups";

@Injectable({
  providedIn: 'root'
})
export class ImageLightboxService {

  constructor() {
    (window as any).NG_IMAGE_LIGHTBOX_SERVICE = this;
  }

  onClick($event: any) {
    const src = $event.target.attributes.src.value;
    const alt = $event.target.attributes.alt?.value || "";

    const dialog = DialogUtility.alert({
      title: null,
      content: `<img src="${src}" alt="${alt}">`,
      isModal: true,
      showCloseIcon: true,
      closeOnEscape: true,
      position: {
        X: "center", // Has to be lowercase, which is unusual for Syncfusion
        Y: "center", // Has to be lowercase, which is unusual for Syncfusion
      },
      cssClass: 'image-lightbox',
    });

    dialog.buttons = []; // The dialog utility builds an ok button by default which we don't want, so we remove it.
  }
}
